<template>
  <el-button class="eb-button-orange" @click="sendCodeBtn($event)" v-bind="sendCodeBtnData">{{sendCodeBtnData.text}}</el-button>
</template>
<script>
import { initVerificationCodeStatus, sendCode } from '@/services/model-service';
import Cookies from 'js-cookie';
export default {
  name: 'ebSendCode',
  props: {
    butId: {
      type: String
    },
    params: {
      type: Object
    }
  },
  data() {
    return {
      sendCodeBtnData: {
        text: '获取验证码',
        disabled: false,
        storeKey: this.butId,
        time: Cookies.get(this.butId + 'time') || 60,
        disBtn: Cookies.get(this.butId + 'disBtn'),
        inter: null
      }
    };
  },
  created() {
    initVerificationCodeStatus(this, this.sendCodeBtnData);
  },
  methods: {
    init(btnObj) {
      if (btnObj.storeKey === this.butId) {
        this.sendCodeBtnData = btnObj;
      }
    },
    sendCodeBtn: function(e) {
      initVerificationCodeStatus(this, this.sendCodeBtnData);
      sendCode(this, this.params, this.sendCodeBtnData);
    }
  }
};
</script>
